import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CheckboxGroupBase from "@/components/CheckboxGroup.Base.vue";

export default defineMosaicComponent<typeof CheckboxGroupBase>("components/CheckboxGroup");
